import React, { useState, useEffect } from "react"

import ExtendedCodeExample from "./ExtendedCodeExample"

import SyntaxHighlighter from 'react-syntax-highlighter'
import { dracula } from 'react-syntax-highlighter/dist/esm/styles/hljs'

import codeExampleStyles from "./CodeExample.module.css"

export default function CodeExample({id, codeList, requestDescription, defaultLanguage, title, onChange}) {

    //console.log("codeList.example_extended: ",codeList)

    const [ open, setOpen ] = useState(false)

    ////////////////////////////////////////////////////////////////////////////////
    // use this to control state if this is localized version rendered from .md file
    let isInsideMdInitialState = false
    if(onChange === undefined){
        isInsideMdInitialState = true
    }

    const [ insideMd ] = useState(isInsideMdInitialState)

    const [ selectedLang, setSelectedLang ] = useState(defaultLanguage)

    const updateLanguage = (lang) => {
        insideMd
        ? setSelectedLang(lang)
        : onChange(lang)
    }

    defaultLanguage = insideMd ? selectedLang : defaultLanguage
    /////////////////////////////////////////////////////////////////////////////////
    ////////////////////////////////////////////////////////////////////////////////

    // monitor the state of the toggle
    // add/remove click event handler to the document
    useEffect(() => {
        const clickHandler = ({ target }) => {
            const container = document.getElementById(`${id}`)

            if(target.getAttribute("data-type") === 'langSelector') setOpen(false)
            if (container.contains(target) && target.getAttribute("id") === `${id}_langSelector`) {
                return
            }            
            setOpen(false)
        }

        document.addEventListener("click", clickHandler)

        // these functions clean up the event listeners
        return () => document.removeEventListener("click", clickHandler)
    })         
    
    const codeSelectors = codeList.map( ({name}, index) => 
        <li key={index}>
            <button 
                className={name === defaultLanguage ? codeExampleStyles.selected : ""} 
                data-type='langSelector' 
                onClick={ () => updateLanguage(name) }
            >
                {name}
            </button>            
        </li>
    )  

    const codeExamples = codeList.map( ({example, name, example_extended}, index) => 
        <div key={index} data-example={name} className={name === defaultLanguage ? codeExampleStyles.show : ""}  >    
            {
                example &&
                <SyntaxHighlighter language={name} style={dracula}>
                    {example}
                </SyntaxHighlighter>                 
            }                   
            {
                example_extended && 
                <ExtendedCodeExample data={example_extended} language={name} />
            }
        </div>
    )   


    return (
        <div id={id} className={codeExampleStyles.container}>
            <div className={codeExampleStyles.header}>
                <div className={codeExampleStyles.title}>
                    <div> { title ? title : "Request Example" } </div>
                    <div className={codeExampleStyles.langSelector}>
                        {
                            codeSelectors.length > 1 
                            ?
                            <button 
                                id={`${id}_langSelector`}
                                aria-expanded={open ? "true" : "false"}
                                className={open ? codeExampleStyles.active : ""}                
                                onClick={ () => setOpen(!open) }>
                                {/* {defaultLanguage} */}                           
                                { insideMd ? selectedLang : defaultLanguage}
                            </button>
                            :
                            <button className={codeExampleStyles.noDropDown} >                                                       
                                { insideMd ? selectedLang : defaultLanguage}
                            </button>                          
                        }

                        <div className={open ? `${codeExampleStyles.langList} ${codeExampleStyles.show}` : codeExampleStyles.langList}>
                            <ul>
                                {codeSelectors}                              
                            </ul>                             
                        </div>
                    </div>               
                </div>
                { requestDescription && 
                    <p>{requestDescription}</p>
                }
            </div>
            <div className={codeExampleStyles.codeBlocks}>
                {codeExamples}
            </div>
        </div>
    )
}